'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxOfficeDetails } from './OfficeDetails'

interface OfficeDetailsProps {
  blok: {
    address: string
    phone: string
    hours: string
    formId: string
    location: any
    mailingAddress: string
  } & SbBlokData
}

const OfficeDetails: FC<OfficeDetailsProps> = ({ blok }) => {
  const latToAssign = Number(blok.location[0].latitude)
  const longToAssign = Number(blok.location[0].longitude)
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxOfficeDetails
        address={blok.address}
        phone={blok.phone}
        hours={blok.hours}
        formId={blok.formId}
        form={blok.form}
        mailingAddress={blok.mailingAddress}
        location={{
          lat: latToAssign,
          long: longToAssign,
        }}
      />
    </div>
  )
}

export default OfficeDetails
